export const meta: BlockMeta = {
  title: "Page Header",
  description: "A header for the page",
  keywords: ["text", "wysiwyg", "content"],
  icon: "calendar",
  category: "text",
  cache: false,
  tags: ["root"],
  postMetaBlock: {
    postTypes: ["page"],
    fieldName: "pageHeader2",
  },
  inserter: false,
}

import { useIsLoggedIn } from "@features/accounts/hooks/useAuth"
import { defineBlock, EditableText, InnerBlocks, usePostTitleEditor } from "eddev/blocks"
import { useRoute } from "eddev/routing"

export default defineBlock("page/page-header", (props) => {
  const [postTitle] = usePostTitleEditor()
  const route = env.admin ? undefined : useRoute()
  const loggedIn = useIsLoggedIn()

  return (
    <>
      {props.style === "normal" && (
        <div className="mb-6">
          {route?.pathname === "/membership" && loggedIn ? (
            <div className="!type-title-l-medium">
              <strong>Manage your AGDA Membership</strong>
            </div>
          ) : (
            <>
              <EditableText className="!type-title-l-medium" store="title" placeholder={postTitle ?? ""} defaultValue={(props.contentNode as any)?.title} />
              <EditableText as="p" className="!type-title-l-roman mt-1" store="subtitle" placeholder={"Enter an optional subtitle"} />
            </>
          )}
        </div>
      )}
      {props.style === "underline" && (
        <EditableText className="!type-title-xs-medium pb-4 w-full mb-4 border-b" store="title" placeholder={postTitle ?? ""} defaultValue={(props.contentNode as any)?.title} />
      )}
    </>
  )
})
